import './synchro-view.scss'

import { defineComponent } from 'vue';
import { faCalendarAlt, faCaretDown, faCaretRight, faCircleNotch, faStopwatch, faSyncAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

import { DataSynchronisationStatus } from '@skinsoft/types';
import { formatDateFromNow, formatDuration } from '@skinsoft/utils';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator';

export const SynchroView = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sOnlineStatusIndicator: OnlineStatusIndicator
    },
    props: ['synchDownHandler', 'title'],
    template: require('./synchro-view.html'),
    data() {
        return {
            syncing: false,

            // Icons
            syncIcon: faSyncAlt,
            durationIcon: faStopwatch,
            lastDateIcon: faCalendarAlt,
            loadingIcon: faCircleNotch,
            crossIcon: faTimes,
            rightArrow: faCaretRight,
            downArrow: faCaretDown,

            progressBarVariant: "success",
            collapsed: true,
        }
    },
    mounted() {
        switch (this.synchDownHandler.getLastSyncStats()?.lastSynchroStatus) {
            case DataSynchronisationStatus.SUCCESS:
                this.progressBarVariant = "success"
                break;
            default:
                this.progressBarVariant = "danger"
                break;
        }

        this.syncing = this.synchDownHandler.isSyncing();
    },
    computed: {
        synchroNbMax() {
            return this.synchDownHandler.getLastSyncStats()?.maxNbToSynchronize;
        },
        synchroNbCurrent() {
            return this.synchDownHandler.getLastSyncStats()?.currentNbSychronized;
        },
        progressBarValue(): number | undefined {
            // to fix a display bug of b-progress-bar when max is 0
            if(this.synchroNbMax === 0 && this.synchroNbCurrent === 0) {
                return 1
            }

            return this.synchroNbCurrent
        },
        progressBarMax(): number | undefined {
            // to fix a display bug of b-progress-bar when max is 0
            if(this.synchroNbMax === 0 && this.synchroNbCurrent === 0) {
                return 1
            }

            return this.synchroNbMax
        },
        lastSynchroDuration() {
            if (this.synchDownHandler.getLastSyncStats()?.lastSynchroDuration) {
                return formatDuration(this.synchDownHandler.getLastSyncStats()?.lastSynchroDuration,
                    this.$t('time.minutes'), this.$t('time.seconds'))
            }
        },
        lastSynchroDate() {
            return formatDateFromNow(
                this.synchDownHandler.getLastSyncStats()?.lastSynchroDate,
                this.getAppLocale()
            )
        },
        lastSynchroStatus() {
            return this.synchDownHandler.getLastSyncStats()?.lastSynchroStatus ?? DataSynchronisationStatus.NONE;
        },
        isSyncing() {
            return this.synchDownHandler.isSyncing()
        },
    },
    methods: {
        synchronize() {
            const synchroStats = this.synchDownHandler.getLastSyncStats()
            if (synchroStats) {
                synchroStats.lastSynchroStatus = DataSynchronisationStatus.SUCCESS;
            }
            this.progressBarVariant = "success";
            this.syncing = true;
            this.synchDownHandler.synchronize(0, true, true);
        },

        abortSynchronisation() {
            this.synchDownHandler.abortSynchronisation();
            this.progressBarVariant = "danger";
            this.syncing = false;
        },
    },
    watch: {
        // not sure if usefull TODO test if it is really needed
        isSyncing() {
            this.syncing = this.synchDownHandler.isSyncing();
            if (this.synchDownHandler.getLastSyncStats()?.lastSynchroStatus !== DataSynchronisationStatus.SUCCESS) {
                this.progressBarVariant = "danger";
            } else {
                this.progressBarVariant = "success";
            }
        },
    },
})
